<template>
    <v-dialog
        v-model="show"
        width="500">
        <v-card>
            <v-card-title class="headline">Sunteti sigur ca doriti sa stergeti fisierul {{ currentFile.name }}?</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="close">Anulare</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItem">Confirmare</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import ConfirmDeleteModal from "../../../../packages/media-manager/js/components/subcomponents/ConfirmDeleteModal";

    export default {
        extends: ConfirmDeleteModal
    };
</script>

<style>
</style>
